import { FC } from "react";
import { HStack, Text, Badge } from "@chakra-ui/react";
import { IKaTableProps, Table as KaTable } from "ka-table";
import { ICellTextProps } from "ka-table/props";
import {
    AppOptionBoxItem,
    AppOptionsBox,
    KaPageSizeSelector,
} from "../../../components";
import { DonationTransaction } from "../../../apis";
import { useAppUtil } from "../../../hooks";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { APPC } from "../../../config";

export const DonationTransactionList: FC<{
    kaTableProps: IKaTableProps;
    actionOptions: AppOptionBoxItem[];
    actionClickHandler: (key: string, data?: DonationTransaction) => void;
}> = ({ kaTableProps, actionOptions, actionClickHandler }) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const { statusVariant } = useAppUtil();
    return (
        <>
            <KaTable
                {...kaTableProps}
                childComponents={{
                    pagingSizes: {
                        content: (props) => <KaPageSizeSelector {...props} />,
                    },
                    cellText: {
                        content: (props: ICellTextProps) => {
                            switch (props?.column?.key) {
                                case "id":
                                    return (
                                        <Text>
                                            {`DT-${dayjs(
                                                props?.rowData?.createdAt
                                            )
                                                .tz(APPC.TIMEZONE)
                                                .format(
                                                    "YYYYMMDD"
                                                )}-${props?.rowData?.id}`}
                                        </Text>
                                    );
                                case "createdAt":
                                    return (
                                        <Text>
                                            {dayjs(props?.rowData?.createdAt)
                                                .tz(APPC.TIMEZONE)
                                                .format("DD-MM-YYYY HH:mm:ss")}
                                        </Text>
                                    );
                                case "amount":
                                    return (
                                        <Text textStyle={"mediumSm"}>
                                            &euro;{" "}
                                            {props?.rowData?.amount / 100}
                                        </Text>
                                    );
                                case "isSubscription":
                                    return (
                                        <Badge
                                            variant={
                                                props?.rowData?.isSubscription
                                                    ? "green"
                                                    : "red"
                                            }
                                        >
                                            {props?.rowData?.isSubscription
                                                ? "Yes"
                                                : "No"}
                                        </Badge>
                                    );
                                case "status":
                                    return (
                                        <Badge
                                            variant={statusVariant(
                                                props?.rowData?.status
                                            )}
                                        >
                                            {props?.rowData?.status}
                                        </Badge>
                                    );
                                case "action":
                                    return (
                                        <HStack justify={"flex-end"} gap={3}>
                                            <AppOptionsBox<DonationTransaction>
                                                options={actionOptions}
                                                data={props?.rowData}
                                                onClick={actionClickHandler}
                                            />
                                        </HStack>
                                    );
                            }
                        },
                    },
                }}
            />
        </>
    );
};
